import {PromissoryNoteOptionEnum} from '@/models/digital-document-promissory-note-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function promissoryNoteOptionNameFilter(option: PromissoryNoteOptionEnum) {
  switch (option) {
    case PromissoryNoteOptionEnum.LostRentedVehicle: return i18n.t(LF.LostRentedVehicle) as string;
    case PromissoryNoteOptionEnum.RepaymentOfRentArrearsDueToSalary:  return i18n.t(LF.RepaymentOfRentArrearsDueToSalary) as string;
  }
}
